import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1267876c")

_pushScopeId("data-v-1267876c")
const _hoisted_1 = {
  key: 0,
  class: "module-swiper"
}
const _hoisted_2 = { class: "swiper-slide-wrapper" }
const _hoisted_3 = { class: "swiper-silde-container" }
const _hoisted_4 = {
  key: 2,
  class: "swiper-slide-desc"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_ctx.list && _ctx.list.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: `swiper-slide-button-prev swiper-slide-button-prev-${_ctx.currentTime}`
        }, null, 2),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_swiper, {
            initialSlide: _ctx.list.length - 1,
            modules: _ctx.swiperModules,
            loop: true,
            autoHeight: true,
            onSwiper: _ctx.onSwiper,
            navigation: {
          nextEl: `.swiper-slide-button-next-${_ctx.currentTime}`,
          prevEl: `.swiper-slide-button-prev-${_ctx.currentTime}`,
        }
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, { key: k }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_3, [
                      (i.img)
                        ? (_openBlock(), _createBlock(_component_ImgContainer, {
                            key: 0,
                            class: _ctx.isImgNeedBorder ? 'border' : '',
                            src: i.img,
                            noLazy: true
                          }, null, 8, ["class", "src"]))
                        : _createCommentVNode("", true),
                      (!i.img && i.video)
                        ? (_openBlock(), _createBlock("video", {
                            key: 1,
                            src: i.video,
                            poster: i.poster ? i.poster : '',
                            controls: "controls",
                            preload: "auto",
                            "x5-playsinline": "true",
                            playsinline: "true",
                            "webkit-playsinline": "true",
                            onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoPlay && _ctx.handleVideoPlay(...args)))
                          }, null, 40, ["src", "poster"]))
                        : _createCommentVNode("", true),
                      (i.desc)
                        ? (_openBlock(), _createBlock("div", _hoisted_4, [
                            _createVNode("p", null, _toDisplayString(i.desc), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["initialSlide", "modules", "onSwiper", "navigation"])
        ]),
        _createVNode("div", {
          class: `swiper-slide-button-next swiper-slide-button-next-${_ctx.currentTime}`
        }, null, 2)
      ]))
    : _createCommentVNode("", true)
})